import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Input() display;
  @Output() displayChange: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

}
